import { Injectable } from '@angular/core';
import { OrderType, OrderTypeEnum } from '../models/new/order';

@Injectable({
	providedIn: 'root'
})
export class OrderTypeMapper {
	toOrderType(orderType: any): OrderType {
		return new OrderType({
			id: this.toOrderTypeEnum(orderType?.id),
			name: orderType?.name
		});
	}

	toOrderTypeEnum(id: number): OrderTypeEnum | undefined {
		switch (id) {
			case 1:
				return OrderTypeEnum.Complete;
			case 2:
				return OrderTypeEnum.Dressed;
			case 3:
				return OrderTypeEnum.StillLife;
			default:
				return undefined;
		}
	}
}
